import React, { useEffect, useState } from 'react';

const UtilisateurList = ({utilisateurs}) => {

    return (
        <div>
            <h1>Liste des Utilisateurs</h1>
            <ul>
                {utilisateurs && utilisateurs.length > 0 ? (
                    utilisateurs.map((utilisateur) => (
                        <li key={utilisateur.id}>{utilisateur.username}{utilisateur.roles.includes('ROLE_ADMIN') && <span> (Admin)</span>}</li>
                    ))
                ) : (
                    <li>Aucun utilisateur trouvé</li>
                )}
            </ul>
        </div>
    );
};

export default UtilisateurList;